module.exports = __webpack_public_path__ + "static/media/teams-add-new-employees.68da1216.svg";